// extracted by mini-css-extract-plugin
export default {"sib-close-btn":"sSQQcLrPOf2OAbZ5CsDS","sib-btn":"Fc23TZtydy9Jym_VlfTl","sib-btn_icon-stand-alone":"XmtLsBe4M0fEarmveF0P","sib-btn_size--small":"e1tlfwXIDr_KmGhevzip"};